export default __webpack_public_path__ + "static/media/footer-bg.f27c4108.jpg";